'use strict';

angular.module('shiftTraderApp')
  .directive('smartSchedulingEmployeeListItem', ['SmartSchedulingCoordinator', '$rootScope', function (SmartSchedulingCoordinator, $rootScope) {
    return {
      templateUrl: 'views/directives/smartSchedulingEmployeeListItem.html',
      restrict: 'A',
      require: '^^saSmartScheduling',
      link: function(scope, elem, attrs, ctrl) {
        var disposableSubscriptions = [];

        scope.state = {
          busyCalculating: true
        };

        scope.sendEmpToInfoBar = function() {
          $rootScope.$broadcast('sa:employeeSelectedForInfo', scope.emp);
        };

        scope.empId = parseInt(attrs.empId);
        scope.smartSchedulingCtrl = ctrl;
        scope.coordinator = SmartSchedulingCoordinator.getCoordinatorByName(ctrl.getCoordinatorName());
        scope.updateChannel = scope.coordinator.channel.getChannel();

        var hoursElem = $(elem).find('.indicator_circle_assign_smart_sched span');
        var assignmentBtn = $(elem).find('button.sa_button');
        var colorBarLeft = $(elem).find('.color_bar_left');
        var lastColorClassName;

        scope.setColorClass = function() {
          var temp = scope.currentAnalysis.colorClassName;

          if (temp !== lastColorClassName) {
            colorBarLeft.removeClass(['gray_gradient', 'charcoal_gradient', 'green_gradient', 'orange_gradient', 'rouge_gradient'].join(' '));
            colorBarLeft.addClass(temp);
          }

          lastColorClassName = temp;
        };

        scope.setHoursThisWeek = function(hrs) {
          hoursElem.html(hrs);
        };

        scope.setAssignmentState = function(isAssigned) {
          if (isAssigned) {
            assignmentBtn.addClass('sa_gray').removeClass('sa_green').html('Unassign');
          } else {
            assignmentBtn.addClass('sa_green').removeClass('sa_gray').html('Assign');
          }

        };

        scope.setTraining = function(isSet) {
          if (isSet) {
            $(elem).find('.base_smart_cwp_training .training_indicator_smart_sched_list_placement').addClass('show');
          } else {
            $(elem).find('.base_smart_cwp_training .training_indicator_smart_sched_list_placement').removeClass('show');
          }
        };

        scope.setCalculateState = function(isCalculating) {
          if (isCalculating) {
            $(elem).find('icon-spinner').show();
          } else {
            $(elem).find('.icon-spinner').hide();
          }
        };

        disposableSubscriptions.push(scope.updateChannel.
          filter(function(update) {
            return (update.type === 'analysisStart' && update.data === scope.empId) ||
              (update.type === 'analysisUpdate' && update.data.user.id === scope.empId);
          }).subscribe(function(update) {
            if (update.type === 'analysisStart') {
              scope.state.busyCalculating = true;
              scope.setCalculateState(scope.state.busyCalculating);
              scope.setAssignmentState(false);

            } else if (update.type === 'analysisUpdate') {
              scope.currentAnalysis = update.data;
              scope.$applyAsync(function() {
                scope.emp._listOrdering = scope.currentAnalysis.listRankingIndex;
              });

              scope.setColorClass();
              scope.setAssignmentState(scope.currentAnalysis.isAssignedToShift);
              scope.setHoursThisWeek(scope.currentAnalysis.isAssignedToShift ? scope.currentAnalysis.hoursThisWeekWithShiftCeil : scope.currentAnalysis.hoursThisWeekCeil);
              scope.setTraining(scope.currentAnalysis.isTrainingInPosition);
              scope.state.busyCalculating = false;
              scope.setCalculateState(scope.state.busyCalculating);
            }

          }));

        var temp = scope.coordinator.getAnalysisForEmpId(scope.empId);
        if (temp) {
          scope.currentAnalysis = temp.analysis;
        }

        if (scope.currentAnalysis) {
          scope.setHoursThisWeek(scope.currentAnalysis.isAssignedToShift ? scope.currentAnalysis.hoursThisWeekWithShiftCeil : scope.currentAnalysis.hoursThisWeekCeil);
          scope.setAssignmentState(scope.currentAnalysis.isAssignedToShift);
          scope.setTraining(scope.currentAnalysis.isTrainingInPosition);
          scope.emp._listOrdering = scope.currentAnalysis.listRankingIndex;
          scope.setColorClass();
        }

        scope.setCalculateState(scope.state.busyCalculating);

        scope.$on('$destroy', function() {
          console.log('destroy');
          // hoursElem = null;
          // assignmentBtn = null;
          // colorBarLeft = null;

          lodash.invoke(disposableSubscriptions, 'dispose');
        })

      },
      controller: ['$scope', function ($scope) {
        $scope.addUserToShift = function() {
          $scope.$emit('addUserToShift', $scope.emp);
        };

        $scope.unassignUserFromShift = function() {
          $scope.$emit('unassignUserFromShift');
        };

      }]
    };
  }]);
